export const RutasPublicas = {
    INICIO_SESION: 'login'
}
